export function isAppWebView() {
  let result = false;
  // #ifdef H5
  if (navigator.userAgent.indexOf("uni-app") != -1) {
    result = true;
  }
  // #endif
  return result;
}

export function isMiniWechatWebView() {
  const result = false;
  return false;
  // #ifdef H5
  // if (navigator.userAgent.toLocaleLowerCase().indexOf("miniprogram") > -1) {
  //   result = true;
  // } else {
  //   wx?.miniProgram?.getEnv(function (res: any) {
  //     result = res.miniprogram;
  //   });
  // }
  // // #endif
  // return result;
}
